export const PurchaseOrderLabel = "Purchase Order";
export const EditPurchaseOrderLabel = "Edit Purchase Order";
export const AddPurchaseOrderLabel = "Add Purchase Order";
export const EditReceivedPurchaseOrderLabel = "Edit Received Purchase Order";
export const ReceivedPurchaseOrderLabel = "Received Purchase Order";
export const EditGRNTitle = "Edit GRN";
export const AddGRNTitle = "Add GRN";
export const IndentationLabel = "Indentation";
export const IndentIdLabel = "Indent Id";
export const IndentIdKey = "indent_id";
export const VendorIdLabel = "Vendor Id";
export const VendorIdKey = "authUser.id";
export const VendorNameLabel = "Vendor Name";
export const VendorNameFormikKey = "vendor_name";
export const RateLabel = "Rate";
export const OrderDateLabel = "Order Date";
export const OrderDateKey = "order_date";
export const PO_ID_LABEL = "PO Id";
export const ID_KEY = "id";
export const VENDOR_ID_LABEL = "Vendor Id";
export const VENDOR_ID_KEY = "vendor_id";
export const VendorNameKey = "authUser.name";
export const VENDOR_NAME_KEY_FOR_NAME = "vendor_name";
export const BatchNoLabel = "Batch No.";
export const IndentDraftIdKey = "indent_draft_id";
export const ProductCodeLabel = "Product Code";
export const PRODUCTS_LABEL = "Product";
export const PRODUCTS_KEY = "totalProductItem";
export const AvailableQuantityLabel = "Available Quantity";
export const WarningLabel = "Warning";
export const QuantityLabel = "Quantity";
export const QUANTITY_ERROR =
  "Quantity must be less than or equal to available quantity";
export const RecievedQuantityLabel = "Recieved Quantity";
export const RECEIVED_QUANTITY_KEY = "received_quantity";
export const PendingQuantityLabel = "Pending Quantity";
export const PRODUCT_QUANTITY_KEY = "product_quantity";
export const QuantityKey = "quantity";
export const ProductsKey = "products";
export const PO_STATUS_LABEL = "PO Status";
export const GRN_STATUS_LABEL = "GRN Status";
export const PAYMENT_STATUS_LABEL = "Payment Status";
export const POStatusKey = "po_status";
export const PAYMENT_STATUS_KEY = "po_status";
export const DeliveryDateKey = "delivery_date";
export const ReceivedDateLabel = "Received Date";
export const ReceivedDateKey = "received_date";
export const DownloadLabel = "Download";
export const CompanyNameLabel = "MACHINE ELEMENTS";
export const AmountLabel = "Amount";
export const TaxLabel = "Tax";
export const TotalCostLabel = "Total Cost";
export const DateLabel = "Date: ";
export const DateOfIssueLabel = "Date of Issue";
export const ExpectedDeliveryDateLabel = "Expected Deliverty Date";
export const AddProductLabel = "+ Add Product";
export const AddGRNLabel = "+ Add GRN";
export const ConvertToPurchaseOrderLabel = "Convert to Purchase Order";
export const ConvertToReceivedLabel = "Convert to Received";
export const DoYouWantToMakePurchaseOrderLabel =
  "Do you want to make purchase order for this indent?";
export const DoYouWantToMakePurchaseOrderNoteLabel = `Note: This will remove this indent. (when purchase order is
                created!)`;
export const EditIndentationLabel = "Edit Indentation";
export const ThisIsComputerGeneratedLabel = `This is computer generated document, No need for
                          signature.`;
export const AddIndentationLabel = "Add Indentation";

export const PurchaseOrderOptions = {
  PENDING: "Pending",
  RECEIVED: "Received",
  // BILLED: "Billed",
  // PARTIALLY_BILLED: "Partially Billed",
  PARTIALLY_RECEIVED: "Partially Received",
};

export const PartRequiaitionLabel = "Part Requisition"
export const EditPrLabel = "Edit Part Requisition"
export const PRIdLabel = "PR Id";
export const ROIdLabel="RO Id";